import { i18n } from 'i18n';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { DETAILS_ROUTE_PATH as dashboardPath } from 'modules/project/ProjectAreaPage/constants';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import useApprovalPresetGroupsQueries, { ApprovalPresetGroupsQueries } from './useApprovalPresetGroupsQueries';

const ApprovalPresetGroupsPage = lazyWithSuspense(() => import('./ApprovalPresetGroupsPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: withLicenceAndDisclaimer({
    pageDataHook: useApprovalPresetGroupsQueries,
    Component: makePage<constants.ApprovalPresetGroupsPageParams, [], ApprovalPresetGroupsQueries>({
      WrappedPage: ApprovalPresetGroupsPage,
      titleFn: () => i18n._(constants.TITLE),
      parentTitleFn: () => i18n._('Dashboard'),
      parentPathTemplate: dashboardPath,
    }),
  }),
};

export default page;
